(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9776],{

/***/ 9776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var _ab_expertos_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96375);
/* harmony import */ var _ab_expertos_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ab_expertos_scss__WEBPACK_IMPORTED_MODULE_2__);



var Expertos = function(param) {
    var _title = param.title, title = _title === void 0 ? "Logros alcanzados y objetivos de futuro" : _title, _text = param.text, text = _text === void 0 ? [
        "Ya puede conocer en Nuestra Quinta Memoria de RSE 2020,  logros alcanzados y objetivos para los pr\xf3ximos a\xf1os, siempre basados en nuestros cinco pilares fundamentales.", 
    ] : _text, _cards = param.cards, cards = _cards === void 0 ? [] : _cards, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-expertos ".concat(className || classname || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        element: "h2",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "logros",
                children: cards === null || cards === void 0 ? void 0 : cards.map(function(itm) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "logro-card",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                        srcSet: (itm === null || itm === void 0 ? void 0 : (ref = itm.imagemobile) === null || ref === void 0 ? void 0 : ref.mediaItemUrl) || itm.imagemobile,
                                        media: "(max-width: 850px)"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (itm === null || itm === void 0 ? void 0 : (ref1 = itm.image) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl) || itm.image,
                                        loading: "lazy",
                                        alt: itm.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        element: "h4",
                                        children: itm.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        element: "span",
                                        className: "title",
                                        children: itm.subtitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        children: itm.description
                                    })
                                ]
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Expertos);


/***/ }),

/***/ 96375:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);